import { useTranslation } from 'react-i18next';
import numbro from 'numbro';

import { SVGIconType } from '../../../constants/svgIcon';
import { PngIcon, SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './DonateBreadPopup.module.css';

type DonateBreadPopupProps = {
  bread: number;
  onPrimary: () => void;
  onCancel: () => void;
};

export const DonateBreadPopup = (props: DonateBreadPopupProps) => {
  const { bread, onPrimary, onCancel } = props;
  const { t } = useTranslation();

  return (
    <BasicPopupContainer
      primaryButtonLabel={t('Donate Now')}
      onPrimaryButtonClick={onPrimary}
      onSecondaryButtonClick={onCancel}
    >
      <div className={styles.popupContent}>
        <SvgIcon
          name={SVGIconType.BreadDonate}
          width={80}
          height={80}
          color="#333333"
        />
        <div className={styles.title}>{t('Donate Bread')}</div>
        <div className={styles.breadBox}>
          <p className={styles.youHaveLabel}>{t('You have:')}</p>
          <div className={styles.breadCount}>
            <PngIcon name="Bread" width={24} height={24} />
            <span>{numbro(bread).format({ thousandSeparated: true })}</span>
          </div>
        </div>
        <div className={styles.description}>
          {t('Donate Bread to those in need?')}
        </div>
      </div>
    </BasicPopupContainer>
  );
};
